import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import {AssetType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data: AssetType | undefined
}

const GalleryPopup = (props: Props) => {
	return <div>{props.data && <NewResponsiveImage {...props.data} />}</div>
}

export default GalleryPopup
